import { useMutation } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface IMapUnmapXeroProjectTasks {
  mapping: boolean;
  data: Array<{ timeero_task_id: number; xero_task_id: number }>;
}

const mapUnmapXeroProjectTasks = (postData: IMapUnmapXeroProjectTasks) => {
  return http().post(endpoints.integrations.xeroMapProjectTasks, postData);
};

export function useMapUnmapXeroProjectTasks() {
  return useMutation({ mutationFn: mapUnmapXeroProjectTasks });
}
